export const messages = {
    //! header
    headerMainPage: "صفحه اصلی",
    headerServices: "خدمات",
    headerChart: "چارت",
    headerPrice: "استعلام قیمت ",
    headerNews: "اخبار",
    headerFAQ: "سوالات متداول",
    headerGallery: "گالری",
    headerAboutUs: "درباره ما",
    headerConcatUs: "تماس با ما",

    //! Home
    //? services
    servicesTitleMainPage: "خدمات",
    servicesMainPage1: 'خدمات فورواردری و حمل و نقل ریلی در کشورهای فعال',
    servicesMainPage2: 'اخذ کلیه موافقت نامه های حمل و مدارک لازم کالا از کشورهای سیر',
    servicesMainPage3: 'انجام تشریفات گمرکی و امورات مرتبط با اتاق بازرگانی',
    servicesMainPage4: 'مشاوره تخصصی و ارائه بهترین و کم هزینه ترین مسیر صادرات',
    servicesMainPage5: 'ترانزیت محموله های ریلی از طریق ایران و کشورهای آسیای میانه',

    //? Statistics
    statisticsTitleMainPage: 'آمار در سال 2023',
    statistics1: 'تناژ صادرات کالا',
    statistics2: 'ارزش دلاری',
    statistics3: 'تعداد واگن ها',

    //? Benefits
    benefitsTitleMainPage: "مزیت های رقابتی گروه آلتن لجستیک",
    benefitsCardTitle1: "سرعت بالای حمل و نقل",
    benefitsCardTitle2: "اطمینان از سلامت بارگیری و حمل کالا",
    benefitsCardTitle3: "شریکان کلیدی متعدد بین المللی معتبر و قابل اطمینان",
    benefitsCardTitle4: "تریسینگ هوشمند و رصد محموله ها در تمامی کشورهای مسیر",
    benefitsCardTitle5: "نیروی انسانی متخصص در طول فرآیندهای تخلیه، بارگیری و انجام تشریفات گمرکی",
    benefitsCardTitle6: "اطمینان از سلامت تحویل کالا در مقصد",
    benefitsCardTitle7: "مشاوره تخصصی به مشتریان و صادرکنندگان",
    benefitsCardTitle8: "واگذاری واگن های باکیفیت با بهترین قیمت",
    benefitsCardTitle9: "امکان پرداخت صورتحساب در تمامی کشورهای منطقه و با هر نوغ پرداخت",
    benefitsCardTitle10: "بکارگیری هوشمندانه از فناوری اطلاعات در مدیریت فرآیندها و خدمات تخصصی به مشتریان",

    //? SelectedImagegallery
    selectedImageGalleryTitleMainPage: "گالری تصاویر منتخب",

    //! FAQ
    //? AccordionQuestionAnswer
    accordionQAs: [
        {
            id: 1,
            question: 'چگونه می توانم واگنی را برای حمل و نقل محموله صادراتی خود به کشورهای آسیای میانه و یا افغانستان اجاره نمایم؟',
            answer: 'ابتدا مشتری باید تقاضای خود را به امور مشتریان گروه آلتن ارائه نماید، اگر مشتری در ایران است میتواند با شماره تلفن 09025613535، آقای مهندس احسان وکیلی (مدیر ارشد لجستیک)، و یا با شماره تلفن 09032218538 ، آقای مهندس آصف ناظریان (مدیر واحد امور مشتریان) تماس حاصل نمایند و یا با ثبت تقاضا در وب سایت، درخواست خود را ارائه نمایند. در این درخواست بایستی، نوع محموله، تناژ تقریبی و شرایط حمل تا ایستگاه را اعلام نمایند و شماره تلفنی برای پیگیری تقاضا ارائه نمایند. این تقاضا سریعا توسط کارشناسان واحد امور مشتریان پیگیری و نتیجه به متقاضی اعلام می گردد.',
        },
        {
            id: 2,
            question: 'هزینه حمل و نقل کالای صادراتی چگونه محاسبه می شود؟',
            answer: 'این هزینه ها شامل مواردی مانند هزینه های تخلیه و بارگیری از کامیونها به واگن اعزامی در ایستگاه مبدا، مهاربندی محموله در واگن، هزینه های ترخیص کالای گمرکی، پرداخت ظهر بارنامه راه آهن جمهوری اسلامی ایران، هزینه کد مسیر (حق سیر واگن در کشورهای مسیر)، هزینه های تعرفه راه آهن در کشور مبدا و کشورهای مسیر و هزینه هایی مانند هزینه آزمایشگاه، قرنطینه و ... می شود. این هزینه ها بسته به نوع واگن، نوع محموله، کشورهای عبوری، طول مسیر و نوع مهاربندی کالا، متفاوت خواهد بود. برای اطلاع از هزینه دقیق، می توانید از طریق استعلام از همین سایت اقدام نمایید. البته هزینه های ترخیص محموله در مقصد و هزینه های انتقال محموله توسط کامیون از کارخانه یا مبدا بارگیری تا ایستگاه راه آهن اینچه برون (یا گرگان یا بندرترکمن) علاوه بر اینها بوده و مشتری مسئولیت آن را بر عهده خواهد گرفت.'
        },
        {
            id: 3,
            question: 'در استان گلستان، از کدام ایستگاههای راه آهن می توانم کالای خود را صادر نمایم؟',
            answer: 'مشتریان می توانند تقاضا نمایند که کالای صادراتی از ایستگاههای اینچه برون، گرگان و یا بندرترکمن به مقاصد خود اعزام گردند. و در این صورت بایستی محموله های خود را از طریق کامیون و در یک روز مشخص که از قبل به اطلاع امور مشتریان می رسد به ایستگاه بارگیری ارسال نمایند. این محموله ها بایستی شرایط بسته بندی استاندارد را رعایت نمایند تا در طول مسیر دچار آسیب نشده و به محموله آسیبی وارد نشود. البته حسب درخواست مشتری، شرکت حمل و نقل می تواند بسته بندی خاص و مهارت بندی ویژه ای را اعمال نماید.',
        },
        {
            id: 4,
            question: 'وظایف شرکت حمل و صادر کننده چگونه است؟',
            answer: 'صادر کننده موظف است در یک روز مشخص که از قبل به اطلاع واحد واگذاری می رسد، کامیونهای حامل محموله را در سقف مشخصی از حجم و تناژ به ایستگاه بارگیری اعزام نمایند. رعایت بسته بندی و زمابندی اعزام کامیونها بر اساس نوع کالای صادراتی بسیار مهم است و مشتریان بایستی ابتدا کامیونهای حامل مواد با بسته بندی محکم تر را ارسال نمایند تا چینش کالاهای متنوع در داخل واگن با مشکل مواجه نشود. ضمنا مشتریان بایستی قبل از خروج واگن، مبلغ کامل هزینه های ارسال محموله صادراتی خود را پرداخت نموده و تسویه نمایند. در موارد مشخص و پس از کسب اعبار لازم نزذ شرکت، مشتریان می توانند فقط با پرداخت قسمتی از هزینه ها امکان صدور واگن را فراهم نمایند. از طرفی شرکت فورواردر، موظف است تمامی فرآیندهای تخلیه محموله از کامیونها به داخل واگن ها را با ارائه صورتحساب، انجام داده و مهاربندی لازم را اعمال نماید. و از مشتری را از سلامت و کیفیت بارگیری مطلع نماید. همچنین شرکت فورواردر در طول سیر واگن، امکان تریسینگ و رصد واگنها را به مشتری ارائه می نماید تا مشتریان بتوانند وضعیت واگن را به صورت روزانه رصد نمایند و برنامه خود را برای ترخیص در مقصد، تنظیم نمایند.',
        },
        {
            id: 5,
            question: 'وب سایت گروه آلتن لجستیک چه امکاناتی را می تواند به مشتریان ارائه نماید؟',
            answer: 'وب سایت آلتن لجستیک (www.AltynLogistics.com)  امکان ثبت تقاضا، اخذ مشاوره، تریسینگ واگنهای در حال سیر، و صورتحساب مشتریان را بهمراه مستندات کامل واگن اعزامی در اختیار مشتریان قرار دهد. همچنین از طریق پورتال آلتن، مشتریان می توانند تمام مراحل و فرایند بارگیری را به صورت زنده مشاهده نموده و ریز هزینه های خود را دریافت نمایند و در صورت نیاز درخواستهای خاص را به گروه بارگیری و تخلیه اعلام نمایند.'
        },
        {
            id: 6,
            question: 'آیا امکان حضور نماینده صادرکننده در ایستگاه بارگیری وجود دارد؟',
            answer: 'بله، شرکت فورواردری، با کسب مجوز از گمرک و راه آهن، امکان حضور نماینده صادرکننده را در محل بارگیری فراهم نموده و نماینده محترم صادرکننده می تواند شخصا بر نحوه بارگیری و شمارش کالا نظارت نماید.',
        },
        {
            id: 7,
            question: 'معمولا در یک واگن چه مقدار کالای صادراتی می توان بارگیری نمود؟ آیا امکان بارگیری کالاهای متنوع وجود دارد؟',
            answer: 'معمولا واگن های مسقف حداکثر تا 68 تن کالا را در خود جای می دهند اما بسته به حجم و بسته بندی کالا این مقدار می تواند متفاوت باشد. همچنین نوع واگن مورد تقاضا نیز در میزان حجم و تناژ محموله صادراتی موثر است. بطور معمول، ظرفیت یک واگن مسقف با ظرفیت سه تریلی برابری می کند. بنابراین می توان کالاهای متنوعی را در این واگن جای داد، مشروط بر اینکه کالاها شرایط صادرات را داشته باشند و از لحاظ گمرکی منعی برای صادرات نباشد.',
        },
        {
            id: 8,
            question: 'آیا شرکت حمل و نقل مسئولیتی برای ترخیص کالا در مقصد دارد؟',
            answer: 'شرکت حمل و نقل صرفا مسئولیت رسیدن محموله را با سلامت در ایستگاه مقصد می پذیرد و وظایف ترخیص کالا و تخلیه واگن بر عهده مشتری و یا تحویل گیرنده است.',
        },
    ],

    //! AboutUS
    aboutUsCards: {
        rajabGazaqh: {
            name: 'رجب قزاق',
            languages: ['فارسی', 'قزاقی', 'ترکی', 'آذری', 'ترکمنی'],
            extra: 'ریاست محترم آلتن گروپ',
        },
        naghimeChamani: {
            name: 'نغیمه چمنی',
            role: 'مدیر عامل',
            languages: ['فارسی', 'قزاقی'],
            location: 'ایران - گلستان - گرگان - خیابان شهید بهشتی',
            description: ['پوشش دهی کامل نیازهای مشتری اصلی ترین هدف آلتن گروپ از ابتدا تا به الان بوده، هدف از تاسیس آلتن میراث گلستان گسترش خدمات این شرکت و پوشش بیشتر نیاز مشتریان منطقه بوده است. افزایش تعاملات با ارگانها و سازمانهای دولتی بالخصوص سازمان بنادر و کشتیرانی جمهوری اسلامی ایران، خدمات متنوع حمل و نقلی، ارائه مجوزات لازم جهت سیر و پوشش سایر شکافتهای خدماتی در منطقه از جمله خدماتیست که آلتن میراث گلستان به مشتریان و سایر شرکتها ارائه می نماید.']
        },
        safarAraghbai: {
            name: 'صفر عراقبای',
            role: 'مدیر فنی',
            languages: ['فارسی', 'قزاقی', 'روسی', 'ترکمنی'],
            location: 'ایران - گلستان - اینچه برون',
            description: [
                `شروع فعالیت آلتن گروپ از جایی آغاز گردید که شرکت آلتن ریل گلستان با استقرار در ایستگاه مرزی اینچه برون ایران شروع به ارائه خدمات به تجار گرامی نموده و کلیه فرایند های حمل و نقل و ترخیص کالا را به صورت کامل به عهده گرفت. اولین شرکت مستقر و ثبت شده در ایستگاه راه آهن اینچه برون، مجهزترین شرکت فوراردری، تخصصی ترین شرکت آماده به ارائه خدمات و سایر عناوین متعدد دیگر همچون برگه زرینی در تاریخچه آلتن گروپ خودنمایی می نماید.`,
                `همواره آلتن گروپ بر اولین و بهترین بودن خود می بالد. همکاری های دیرینه و مستمر و پایدار مشتریان وفادار دال بر کیفیت خدمات آلتن گروپ بوده و خواهد بود.`,
            ],
        },
        ehsanVakili: {
            name: 'احسان وکیلی',
            role: 'مدیر ارشد',
            languages: ['فارسی', 'ترکمنی'],
            location: 'ایران - گلستان - گرگان - خیابان شهید بهشتی',
            description: ['پوشش دهی کامل نیازهای مشتری اصلی ترین هدف آلتن گروپ از ابتدا تا به الان بوده، هدف از تاسیس آلتن میراث گلستان گسترش خدمات این شرکت و پوشش بیشتر نیاز مشتریان منطقه بوده است. افزایش تعاملات با ارگانها و سازمانهای دولتی بالخصوص سازمان بنادر و کشتیرانی جمهوری اسلامی ایران، خدمات متنوع حمل و نقلی، ارائه مجوزات لازم جهت سیر و پوشش سایر شکافتهای خدماتی در منطقه از جمله خدماتیست که آلتن میراث گلستان به مشتریان و سایر شرکتها ارائه می نماید.']
        },
        asefNazerian: {
            name: 'آصف ناظریان',
            role: 'مدیر ارشد',
            languages: ['فارسی', 'انگلیسی', 'ترکمنی'],
            location: 'ایران - گلستان - گرگان - خیابان شهید بهشتی',
            description: [
            ],
        },
        boranBayeva: {
            name: 'بوران بایوا گلنارا ژاریل کاسینونا',
            role: 'مدیر عامل',
            languages: ['روسی', 'قزاقی'],
            location: 'قزاقستان، شیمکنت، منطقه آبای',
            description: [
                `در دنیای لجستیک، فاصله و شکافت های بسیاری وجود داردکه هر یک پدیدآورنده مشکلات و موانعی برای افراد و شرکت های فعال در منطقه هستند. این شرکت با شناخت کامل این شکافت ها سعی بر ایجاد پلی مستحکم و مطمئن در بین شرکت و افراد فعال در کشورهای منطقه جهت تسریع و بهبود فرایند حمل و نقل را دارد. این زنجیره با ارتباط مستقیم و تخصصی بین شرکت های آلتن گروپ با یکدیگر مستحکم و مستمردر جریان قرار گرفته است. ارائه کد های مسیر، ارائه واگن، فراهم آوری بار برگشتی برای واگن های منطقه بالخصوص از خاک ایران، رصد و رهگیری بار، ارائه مجوزات سیر و ... جز خدمات ارزنده ایست که به صورت مطمئن و رسمی به مشتریان و سایر شرکت های منطقه ارائه می-نماید.`,
            ],
        },
        berdinazarOvezov: {
            name: 'بردی نظر عوضوف',
            role: 'مدیر عامل',
            languages: ['فارسی', 'ترکمنی', 'انگلیسی', 'روسی', 'آلمانی'],
            location: 'ترکمنستان، عشق آباد، خیابان آندالیپ 182',
            description: [
                `ترکمنستان، با توجه به موقعیت جغرافیایی استراتژیک، عضویت در کشورهای CIS، زیرساختهای توانمند و درحال توسعه ریلی، هم مرزی با کشورهایی چون قزاقستان و ایران و دریای خرز و سایر پارامترهای مهم لجستیکی، یکی از کشورهای مستعد و جذاب لجستیکی منطقه برای فعالین حمل و نقل می باشد. با توجه به هدف گذاری آلتن گروپ، حضور در این کشور توسط شرکت آلتن حیات به حقیقت پیوست. ارتباط مستقیم با راه آهن و ارگانهای دولتی ترکمنستان، ارائه واگن، رهگیری و رصد محموله های ارسالی و عبوری از خاک ترکمنستان و حمل واگن های عبوری از جمله خدماتیست که شرکت آلتن حیات به کاری گیری زیرساخت های زنجیره وار آلتن گروپ به مشتریان ارائه می نماید.`,
            ],
        },
        abdazizSakhi: {
            name: ' عبدالعزیز سخی',
            role: 'مدیر عامل',
            languages: ['فارسی', 'دری'],
            location: 'افغانستان، کابل، نجاران، منطقه 11',
            description: [
                `آلتن گروپ با توجه به مطالعه و بررسی و حساس بودن کشور افغانستان در مراکز لجستیکی آقینه، تورغندی، خواف و هرات  نیاز مبرم حضور خود را در این مناطق لازم دانسته تا ارائه خدماتی چون فورواردی و بازرگانی و ... به مشتریان  و شرکای تجاری خود را بیش از پیش پوشش دهد. افتخاری دیگر از آلتن گروپ، با ارتباط مستقیم با راه آهن افغانستان و ارگانهای دولتی افغانستان، ارائه خدمات مستقیم و مطمئن در این مراکز به شرکای تجاری خود و مشتریان گرامی است.`,
            ],
        },
        hamedAbbasi: {
            name: 'حامد عباسی',
            role: 'مدیر عامل',
            languages: ['فارسی', 'انگلیسی'],
            location: 'ایران- گلستان - گرگان - خیابان شهید بهشتی',
            description: [
                `شرکت آلتن فناور دیجیتال، شرکتی برخاسته از دل دنیای لجستیک، با بهره گیری از علوم کامپیوتر و برنامه نوسی و با درک دغدغه متخصصین و فعالین صنعت حمل و نقل، برای رفع این نیازها قدم برداشته است. چشم انداز این شرکت، راه اندازی سیستم یکپارچه حمل و نقل در منطقه بوده و برای شروع این کار از خدمات دهی به شرکت های گروه آلتن آغاز نموده است. این شرکت با ترکیب فناوری و لجستیک به هدف خود روز به روز نزدیکتر می گردد. برای مثال ارائه خدمات اتوماسیون سامانه حمل و نقل، رهگیری و رصد واگن و کانتینرهای در مسیر و ارائه سایر زیر ساخت های نوین به تجار، صاحبین واگن، فورواردرها و.... از جمله خدمات ارزنده این شرکت می باشد.`,
            ],
        },
    },

    //? CompanyInfoCard
    languages: 'زبان ها',
    contactInfo: 'اطلاعات تماس',
    description: 'توضیحات',

    //! ContactUs
    contactUsPersonTitle: 'راه های ارتباطی',
    contactUsNumberstitle: 'با ما در ارتباط باشید',
    
    //? contact us cards
    contactUsCards: {
        rajabGazaqh: {
            name: 'رجب قزاق',
            extra: 'ریاست محترم آلتن گروپ',
        },
        ehsanVakili: {
            name: 'احسان وکیلی',
            role: 'مدیر ارشد',
            location: 'دفتر مرکزی گرگان',
        },
        naghimeChamani: {
            name: 'نغیمه چمنی',
            role: 'مدیر عامل',
            location: 'ایران- گلستان - گرگان - خیابان شهید بهشتی',
        },
        boranBayeva: {
            name: 'بوران بایوا گلنارا ژاریل کاسینونا',
            role: 'مدیر عامل',
            location: 'قزاقستان، شیمکنت، منطقه آبای',
        },
        berdinazarOvezov: {
            name: 'بردی نظر عوضوف',
            role: 'مدیر عامل',
            location: 'ترکمنستان، عشق آباد، خیابان آندالیپ 182',
        },
        abdazizSakhi: {
            name: ' عبدالعزیز سخی',
            role: 'مدیر عامل',
            location: 'افغانستان، کابل، نجاران، منطقه 11',
        },
        hamedAbbasi: {
            name: 'حامد عباسی',
            role: 'مدیر عامل',
            location: 'ایران- گلستان - گرگان - خیابان شهید بهشتی',
        },
        safarAraghbai: {
            name: 'صفر عرقبای',
            role: 'واگذاری',
            location: 'دفتر مرکزی گرگان',
        },
        aminMohammadGoog: {
            name: 'امین محمد گوگ',
            role: 'مدیر شعبه اینچه برون',
            location: 'ایستگاه راه آهن اینچه برون',
        },
        soroshMaghsodi: {
            name: 'سروش مقصودی',
            role: 'حسابداری',
            location: 'دفتر مرکزی گرگان',
        },
        molamBardiGoog: {
            name: 'مولام بردی گوگ',
            role: 'عملیاتی اینچه برون',
            location: 'ایستگاه راه آهن اینچه برون',
        },
        shahabKaslakhe: {
            name: 'شهاب کسلخه',
            role: 'گمرکی',
            location: 'ایستگاه راه آهن اینچه برون',
        },
    },

    //! services page
    //! ServicesAltynRail
    services: [
        {
            title: 'خدمات ریلی',
            para: [
                `آلتن گروپ همیشه در تلاش بود تا سهم بیشتری در فرایند لجستیک منطقه داشته باشد، برای مثال شرکت آلتن لجستیک کا زد، با قرار گیری در خاک قزاقستان، محموله های ارسالی به سایر کشورها را رصد و منترل میکند و پس از ارسال واگن ها توسط این شرکت، آلتن افغان محموله را دریافت و پس از تخلیه به آلتن حیات واگذار کرده و پس از جابجایی واگن توسط آلتن حیات به آلتن ریل یا میراث تحویل داده و در ایستگاه مرزی اینچه برون بارگیری مجدد شده و به سرزمین اصلی به صورت باردار بر می گردند. این فراینده به صورت برد-برد بوده علاوه بر کاهش هزینه شرکت های صاحب واگن باعث کاهش هزینه حمل کالا در منطقه شده و در نتیجه تجار محترم هم در این چرخه دغدغه کمتر، کیفیت بالاتر و در نهایت هزینه کمتر خواهند داشت. `,
            ],
        },
        {
            title: 'خدمات عملیاتی',
            para: [],
        },
        {
            title: 'تضمین کیفیت در فرآیند تخلیه و بارگیری در ایستگاه مبدا',
            para: [
                `گروه آلتن لجستیک برای انجام فرآیند تخلیه کالای صادراتی از کامیونهای حمل و بارگیری در واگنهای اعزامی، گروهی متخصص از بهترین ها را گردآورده و تربیت نموده است تا بتواند کیفیت را در این فرآیند تضمین نماید. با آلتن گروپ، مجهزترین شرکت حاضر در ایستگاه اینجه برون، دیگر نگران مشکلات بارگیری در واگنها نباشید. کالاهای با ارزش خود را به ما بسپارید و از کیفیت کار اطمینان داشته باشید. استمرار همکاری مشتریان قدیمی اثبات این ادعای ماست.`,
                `گروه آلتن لجستیک، سازمانی مهارت محور است و به شایستگی نیروی انسانی خود می بالد.`,
            ],
        },
        {
            title: 'ارائه کدهای مسیر و مجوزات لازم حمل و نقل',
            para: [
                `یکی از دغدغه های فورواردها و تجار گرامی در زمینه حمل و نقل ریلی فراهم سازی کدهای مسیر کشورهای عبوری می باشد.`,
                `یکی از اهداف آلتن گروپ از حضور در کشورهای مشترک المنافع، ارائه کدهای مسیر و ارائه موافقت لازم و مجوزات لازم جهت سیر از خاک هر کشور عبوری می باشد. آلتن گروپ با تعامل سازنده با ارگانهای دولتی کشورهای عبوری امکان اخذ مجوزات لازم در کوتاهترین زمان را فراهم می نماید.`,
                ` با افتخار اعلام می کنیم شرکت "آلتن لجستیک کا زد" با قرارگیری در خاک قزاقستان، شهر شیمکنت آماده ارائه خدمات اکسپدیتوری می باشد. شرکت آلتن حیات با حضور در خاک ترکمنستان، شرکت آلتن افغان با حضور در خاک افغانستان و شرکت های آلتن ریل و آلتن میراث با حضور در خاک ایران، این اطمینان را برای مشتری گرامی فراهم می نماید تا سیر محموله ایشان در کشورهای منطقه عاری از هرگونه مشکلات بوده و با رصد کامل نمایندگان آلتن گروپ انجام گردد.`,
            ],
        },
        {
            title: 'انجام تشریفات گمرکی',
            para: [
                `آلتن گروپ، در راستای ارتقای استاندارد های کیفی خود، با به کارگیری متخصصین کارآمد، مجرب و پروتکل های استاندارد برای انجام امور گمرکی و ترخیص کالای تجار و مشتریان گرامی، همیشه در تلاش بوده که ترخیص کالای مشتریان گرامی در کوتاه ترین زمان ممکن "با افتخار ترخیص و ارسال بار فقط در یک روز" به انجام برساند. سابقه و تاریخچه انجام این خدمت همیشه باعث اقتدار آلتن گروپ بوده و خواهد بود.`,
            ],
        },
        {
            title: 'مشاوره لجستیکی',
            para: [
                `تیم مدیریتی آلتن گروپ با به دوش کشیدن تجربه سالیان متمادی، شامل افراد متخصص بوده که در حوزه و منطقه فعالیت خود، با آنالیزهای دوره ای پارامترهای موثر در لجستیک، آماده ارائه مشاوره لجستیکی و بازرگانی جهت کاهش ریسک و افزایش امنیت تجارت شما می باشد. این تیم، با شناخت کامل منطقه و بررسی کامل گزینه های موجود در سیر کالا بهترین انتخاب را برای شما روشن و آشکار می کند. هر زمان که اراده کنید، مشاورین ما هم به صورت تلفنی و هم از طریق شبکه های اجتماعی و هم از طریق وب سایت آلتن لجستیک، نیاز شما به راهنمایی را مرتفع خواهند نمود. حتی اگر تاکنون کالایی صادر نکرده باشید، گمشاورین گروه آلتن، به طور کامل شما را در این مسیر بسیار پیچیده همراهی خواهند نمود. گروه آلتن لجستیک، اطمینان را برایتان به ارمغان خواهد آورد.`,
            ],
        },
        {
            title: 'فناوری',
            para: [
                `امروزه به کارگیری فناوری در صنعت و کسب و کار جز لاینفک فرایند تجاری بوده، آلتن گروپ با تاسیس شرکت آلتن فناور دیجیتال با فهم کامل از دغدغه های صنعت حمل و نقل و بررسی و مطالعه همه جانبه آن، سعی بر مهندسی فرایند نموده و با بکارگیری مهندسین و برنامه نویسان بسترهای لازم بکارگیری از این ابزار مشترک را فراهم نموده است. با آلتن گروپ خدمات بسیاری را به صورت آنلاین دریافت خواهید کرد. خدماتی شامل : رهگیری واگن های در مسیر، نظارت بر فرایند تخلیه و بارگیری در مبدا، دریافت صورتحسابو پرداخت آنلاین و بسیاری از خدمات دیگر از طریق آلتن گروپ تجربه کنید.`,
            ],
        },
    ],
    servicesAltynRail: [
        {
            type: 'paragraph',
            title: 'سرویس حمل و نقل ریلی آلتن',
            para: [
                `حمل و نقل ریلی یکی از روش های حمل و نقل زمینی است که برای جابجایی بار و مسافر از
                خطوط راه آهن، قطار و ایستگاه‌های قطار استفاده می‌کند. حمل و نقل ریلی (Railroad
                Transportation) را می‌توان قسمتی از زنجیره لجستیکی حمل و نقل بار در سطح بین
                المللی دانست که منجر به رشد اقتصادی و بالا رفتن میزان ترانزیت می‌گردد. یکی از
                اصلی‌ترین مزیت های حمل و نقل ریلی امکان حمل بارهای بسیار سنگین و فله توسط ناوگان
                ریلی است که از عهده وسایل نقلیه دیگر خارج است و يا صرفه اقتصادي در پي نخواهد .
                از دیگر مزایای این روش می توان به ایمنی بالا، امکان ارسال بار در وزن و حجم بالا،
                امکان ارسال بار در مقیاس طولانی و استفاده از این روش در حمل و نقل ترکیبی
                (جاده‌ای و دریایی) اشاره کرد. هر واگن قطار معادل تقریبا 2.5 کامیون محموله ظرفیت
                دارد. برای مثال فرض کنید یک کالا در یک کامیون 22 تنی یا 23 تنی قرار گیرد؛ حالا
                همان کالا میتواند در یک سوم یک واگن قطار قرار گیرد و هنوز فضا برای کالاهای دیگر
                باشد. بنابراين می‌توان گفت حمل و نقل ریلی از این جهت بسیار به سود صاحبان کالا
                است زیرا کالا با هزینه کمتری حمل می‌شود. در اینجا به برخی از مزایای حمل‌ونقل
                ریلی نسبت به سایر روش‌های حمل‌ونقل اشاره می‌شود:`
                ,
                `نياز به سوخت کمتر: حمل‌ونقل ریلی در مقایسه با روش‌ حمل‌ونقل جاده‌ای نیاز به سوخت
                کمتری دارد. در نتیجه هزینه سوخت حمل‌ونقل ریلی نیز کمتر است (به خصوص برای حمل بار
                در حجم بالا).`
                ,
                `آلودگی کمتر: قطارها در یک مسافت مشخص سوخت کمتری نسبت به کامیون‌ها می‌سوزانند، از
                این رو حمل‌ونقل از طریق قطار سازگارتر با محیط زیست است. طبق گزارش انجمن راه آهن
                آمریکا(AAR)، راه آهن‌های باری می‌توانند یک تن بار را با یک گالن سوخت به طور
                متوسط 770 كيلومتر جابجا کنند. علاوه بر این، استفاده از حمل‌ونقل ریلی نسبت به
                حمل‌ونقل جاده‌ای می‌تواند انتشار گازهای گلخانه‌ای را تا ۷۵ درصد کاهش دهد و از
                همین رو به حمل و نقل سبز نیز معروف است.`
                ,
                `بزرگترین مزیت حمل‌ونقل ریلی این است که قابل اعتمادترین روش حمل‌ونقل است زیرا
                کمترین تأثیر را از شرایط آب و هوایی مانند باران، مه و غیره در مقایسه با سایر
                روش‌های حمل‌ونقل می‌پذیرد و همچنين راه آهن به عنوان امن‌ترین نوع حمل‌ونقل شناخته
                شده است زیرا احتمال تصادف و خرابی راه‌آهن در مقایسه با سایر روش‌های حمل‌ونقل
                کمتر است.`
                ,
                `از معايب راه آهن مي‌توان به هزينه اوليه بالا جهت احداث مسير،‌عدم انعطاف پذيري به
                علت حركت محدود قطار و عدم وجود خدمات درب به درب بار مي‌باشد.`
            ]
        },
        {
            type: 'paragraph',
            title: 'تاریخچه حمل و نقل ریلی در ایران',
            para: [
                `اگر از تاريخ پر فراز و نشيب راه آهن در زمان قاجار بگذريم، پس از تصویب لایحه
                احداث راه آهن در سال ۱۳۰۵در مجلس شوراي ملي در زمان پهلوي اول، سرانجام در ۲۳ مهر
                ماه سال ۱۳۰۶ شمسی پروژه احداث راه آهن سراسری ایران به دست رضا شاه کلنگ خورد. این
                مسیر یک خط آهن سراسری بود و از شمال شرقی به جنوب غربی ایران می رسید. در سال ۱۳۰۶
                قرارداد نقشه‌برداری برای احداث خطوط راه‌آهن با کنسرسیومی متشکلی از کمپانی
                آمریکایی یولن و شرکت‌های آلمانی فیلیپ هولتسمان- ویولیوس برگر و زیمینس باواونیون
                به بهای هر کیلومتر حداکثر ۳۶۸ تومان بسته شد و در سال ۱۳۱۷ و پس از ۱۱ سال،
                سرانجام راه آهن سراسری ایران که از بندرتركمن (بندرشاه سابق) در جنوب دریای خزر
                آغاز و به بندر امام خمینی در سواحل خلیج فارس می رسید افتتاح شد. به همت دفتر
                مهندسي و تاسيسات زيربنايي راه آهن ج.ا.ا در سال‌هاي اخير، راه آهن سراسری ایران به
                عنوان طولانی‌ترین خط ریلی جهان در فهرست یونسکو ثبت شده و لقب راه آهن شمال جنوب
                ایران را به خود اختصاص داده است. پل ورسک نیز به عنوان نماد راه آهن سراسری ایران
                محسوب می شود که آن هم ثبت ملی و جهانی شده است.`
            ]
        },
        {
            type: 'paragraph',
            title: 'جایگاه ایران در حمل و نقل ریلی جهان',
            para: [
                `کشور‌های آمریکا، چین، روسیه، هند و کانادا طولانی ترین خطوط راه آهن جهان را در
                اختیار دارند. ایران نیز  از منظر زیر ساخت های ریلی در میان ۱۴۳ کشور جهان در
                جایگاه ۴۵ قرار گرفته است. تا پایان سال ۱401 ایران دارای 15037 کیلومتر شبکه ریلی
                راه آهن استاندارد و 100 کیلومتر خطوط آهن عریض در مسیر میرجاوه-زاهدان و خطوط
                ايستگاه‌هاي سرخس و اينچه برون است؛ که بالاتر از کشورهای ترکیه، عربستان، یونان،
                مکزیک و برزیل می باشد. علاوه بر این ایران از لحاظ سهم خطوط ریلی شهری و پروژه‌های
                در حال ساخت، رتبه هفتم جهان را به خود اختصاص داده است. کشورهای چین با ۲۱۰۰
                کیلومتر، آمریکا با ۱۲۱۵ کیلومتر، آلمان با ۹۱۹ کیلومتر، ژاپن با ۷۹۴ کیلومتر، کره
                جنوبی با ۷۷۰ کیلومتر و اسپانیا با ۶۶۰ کیلومتر خطوط ریلی شهری، رتبه های یک تا ششم
                را در این زمینه کسب کرده اند. ایران نیز ۵۵۰ کیلومتر خطوط ریلی شهری دارد و همچنان
                نیز در این زمینه در حال پیشرفت است.`
            ]
        },
        {
            type: 'image',
            src: '/assets/Images/company/rail/bridge-veresk.png',
            text: 'پل ورسک نماد راه آهن سراسری کشور'
        },
        {
            type: 'paragraph',
            title: 'شركت راه آهن ج.ا.ا:',
            para: [
                `شركت راه آهن ج.ا.ا یکی از شرکت‌های زیر مجموعه وزارت راه و شهرسازی است که وظیفه
                نگهداری و تعمیر و همچنین بهره‌برداری از شبکه راه‌آهن ایران را برعهده دارد. لازم
                به ذكر است ساخت و توسعه مسيرهاي ريلي جديد خارج از عهده شركت راه آهن مي‌باشد و بر
                عهده شرکت مادر تخصصی ساخت و توسعه زیربناهای حمل و نقل کشور مي‌باشد.`
                ,
                `پس از اصلاحات انجام شده در اوخر دهه 70 و اوايل دهه 80 شمسي، نقش حاكميتي و دولتي
                اين شركت كاهش يافت و عرصه‌اي براي فعاليت شركت‌هاي خصوصي به وجود آمد. تعمير و
                نگهداري زيرساخت در حوزه خط و ساز‌ه‌هاي فني، ساختمان و تاسيسات، علائم و ارتباطات،
                ناوگان، و همچنين حق انتفاع و بهره برداري از واگن‌هاي مسافري و باري و برخي
                حوضه‌هاي ديگر به بخش خصوص واگذار شده است.`
            ]
        },
    ],
    servicesAltynImportExport: [
        {
            type: 'paragraph',
            title: 'صادرات چیست؟',
            para: [
                `صادرات در بازرگانی به معنای انتقال کالا یا ارسال آن از محل مبدأ به مقصد است.
                طبق تعریف اداره گمرک جمهوری اسلامی ایران منظور از صادرات، خروج کالا از قلمرو
                گمرکی کشور مبدأ همراه با رعایت قوانین و مقررات موجود است. صادرات در آیین
                نامه اجرایی قانون امور گمرکی به دو دسته صادرات قطعی و صادرات موقت تقسیم
                گردیده است. صادرات قطعی به این معنی است که هر نوع کالایی که به جهت فروش به
                کشورهای خارجی صادر می‌شود و صادرات موقت به معنی ارسال کالا به کشورهای خارجی
                جهت به عنوان مثال شرکت در نمایشگاهی یا تعمیر آن است که در نهایت به کشور
                برمی‌گردد.`
            ]
        },
        {
            type: 'list',
            title: 'صادرکننده کیست؟',
            para: [
                `به هر شخص حقیقی و یا حقوقی که دارای کارت بازرگانی و یا مجوز وزارت بازرگانی
                بوده و اقدام به صدور کالا نماید صادرکننده اطلاق می‌شود.`
                ,
                `مدارک لازم برای صادرات کالا :`
            ],
            list: [
                'داشتن کارت بازرگانی معتبر به نام صادر کننده کالا.',
                'داشتن مجوز صدور کالا از وزارت صمت (در شرایطی که موافقت کلی از سوی وزارت صمت برای این کالا اعلام نشده باشد)',
                'داشتن گواهی بهداشت و قرنطینه  کالا',
                'داشتن گواهی استاندارد ( در صورت نیاز به داشتن استاندارد اجباری صادرات آن کالا )',
                'گواهی انرژی اتمی (در صورت نیاز)',
                'تهیه Packing List یا صورت عدل بندی (در صورتی که کالاها گوناگون باشند)',
            ],
        },
        {
            type: 'list',
            title: 'مجوزهای صادرات کالا',
            para: [
                `کالاهای صادراتی با توجه به مجوز صدور به 3 دسته تقسيم مي‌شوند:`
            ],
            list: [
                'کالاهایی که نیاز به مجوز ندارند (با رعایت ضوابط) مانند گواهی بهداشت انسانی، دامی، نباتی و ضوابط استاندارد',
                'کالاهای مشروط که صادرات آنها با کسب مجوز امکان پذیر هستند (پس از اعلام موافقت وزارت خانه‌ها و سازمان‌های مربوط و ابلاغ آن به گمرک توسط وزارت صمت جهت صادرات)',
                'کالاهای ممنوع الصدور که صادرات آنها به دلایل شرعی یا قانونی ممنون می باشند. این موضوع در دست دولت می باشد و در زمان هایی می‌تواند نسبت به تغییر قوانین آن اقدام نمیاد'
            ],
        },
        {
            type: 'list',
            title: 'انواع صادرات',
            para: [
                `صادرات از دیدگاه تجاري و مقياس كار صادرات به ۲ نوع مستقیم و غیرمستقیم تقسیم بندي می‌شود`
            ],
            list: [
                `صادرات مستقیم : 
                    شرکت‌هایی که خریداران خارجی، آنان را تشویق به صادرات می‌کنند، معمولاً از
                    این روش استفاده می‌نمایند. همچنین فروشندگانی که صادرات آنان آن‌ قدر
                    افزایش‌ یافته که می‌توانند هزینه‌های اداره سازمان صادراتی خود را بر عهده
                    بگیرند، نیز از این روش استفاده می‌کنند. شرکت‌هایی می‌توانند به صادرات
                    مستقیم اقدام نمایند که کلیه فعالیت‌های ضروری جهت فروش محصولات خود را در
                    کشور میزبان به عهده گیرند. این فعالیت‌ها عبارت‌اند از : تعیین ظرفیت
                    بازار، یافتن خریدار، تعیین کانال‌های توزیع و انجام امور صادرات مانند
                    آماده کردن اسناد و مدارک، اقدامات مربوط به حمل و بیمه محموله. صادرات
                    مستقیم به اشکال زیر انجام می‌شود : الف) نمایندگان صادراتی ب) نمایندگان
                    فروش سیار ج) شعبه فروش در خارج د) بخش صادرات در داخل کشور ه) بازاریابی
                    رایگان و) سفارش پستی`
                ,
                `صادرات غیرمستقیم : 
                    صادرات غیرمستقیم بیشتر میان شرکت‌هایی که تازه به فکر صادرات افتاده‌اند
                    متداول هست. در این نوع صادرات به سرمایه کمتری نیاز است و شرکت اجباری به
                    استخدام فروشندگان یا اجرای قراردادهای مختلف در خارج از کشور ندارد،
                    همچنین ریسک کمتری متوجه صادرکنندگان است. صادرات غیرمستقیم خود به چند روش
                    قابل‌اجراست . الف) شرکت‌های تجاری ب) شرکت‌های مدیریت صادرات ج)
                    سازمان‌های تعاونی صادرات`
                ,
                `صادرات قطعی : 
                    صادرات قطعی عبارت است از ارسال کالا به خارج از قلمرو گمرکی کشور به‌منظور
                    فروش یا مصرف در کشورهای خارجی. صادرات قطعی از پرداخت حقوق گمرکی و سود
                    بازرگانی و عوارض و مالیات معاف هست ولیکن مشمول هزینه‌های گمرکی است`
                ,
                `صادرات موقت : 
                    کالاهایی که برای انجام منظوری، موقتی به خارج از کشور ارسال و پس از انجام
                    منظور موردنظر اعاده می‌شود، صادرات موقت نامیده می‌شود`
                ,
                `صادرات قطعی در حجم تجاری : 
                    برای حجم یا جنبه تجاری داشتن کالا معیار یا تعریفی مشخص نشده است. در ماده
                    ۳ قانون صادرات و واردات آمده است که مبادرت به امر صادرات و واردات کالا
                    به‌صورت تجاری مستلزم داشتن کارت بازرگانی است و در مورد ملاک تجاری بودن
                    کالا بدین گونه شرح داده است که کالاهایی که به تشخیص گمرک برای فروش، وارد
                    یا صادر می‌گردد، اعم از اینکه به همان شکل یا پس از انجام عملیات تولیدی،
                    تفکیک و بسته‌بندی، به فروش می‌رسد، تجاری تلقی خواهد شد`
                ,
                `صادرات قطعی غیرتجاری : 
                    صادرات قطعی غیرتجاری از طریق پست و مسافر انجام می‌گیرد`
                ,
                `صادرات مجدد : 
                    صادرات مجدد عبارت است از صدور کالاهایی که قبلاً واردشده است. چنانچه
                    صادرات مجدد از طریق بندرها، مناطق آزاد یا انبارهای تحت حفاظت گمرک انجام
                    گیرد مشمول پرداخت حقوق گمرکی نخواهد بود`
                ,
            ],
        },
    ],
    servicesAltynFree: [
        {
            type: 'paragraph',
            title: 'اهمیت ترخیص کالا از گمرک:',
            para: [
                'ترخیص کالا از گمرک مهم‌ترین فرآیند در زمینه واردات کالا به شمار آمده و همچنین این فرآیند بسته به قوانین و مقررات کشورها قوانین و سلسله مراتب گوناگونی را شامل می‌شود. در خصوص انجام این فرآیند مهم همواره لازم است که با مراحل ترخیص کالا از گمرک آشنا باشید و قوانین و مقررات آن را به خوبی بشناسید، چرا که در صورت بروز هرگونه بی‌دقتی و عدم شناخت کافی از مراحل انجام ترخیص کالا از گمرک، ترخیص کالای شما قاچاق شمرده شده و در نتیجه خسارت‌های مالی و اعتباری زیادی را برای شما به وجود می آورد.',
                'شناخت تمام قوانین و مقررات جا به‌ جایی کالاهای وارداتی و یا به عبارتی آشنایی با چگونگی انجام مراحل ترخیص کالا از گمرک می تواند برای هر تاجر و بازرگانی امری مهم و پرفایده باشد؛ اما با توجه به مشغله‌های کاری افراد بهتر آن است که برای انجام تمامی مراحل ترخیص کالا از گمرک این کار را به شرکت‌های فعال در این زمینه بسپارید و همواره برای انجام کارهای مربوط به ترخیص کالای تجارت خود از چنین شرکت‌هایی راهنمایی بگیرید و از تجربیات آن ها در این زمینه بهره‌مند شوید.',
                'در واقع شرکت‌هایی که در زمینه ترخیص کالا از گمرک فعالیت دارند، علاوه بر آنکه با تمام قوانین و مراحل انجام این کار آشنا هستند، بارها و بارها این کار را در مرزهای مختلف و در خصوص جا به جایی انواع مختلف کالاها انجام داده اند و در نتیجه تجربه کافی در این زمینه را دارند؛ بنابراین با سپردن فرآیند ترخیص کالاهای تجارت خود به این شرکت ها نه تنها در وقت خود صرفه جویی می‌کنید بلکه از پرداخت هزینه های سنگین و بیهوده نیز جلوگیری به عمل می‌آورید.',
                'هلدينگ آلتن از جمله شرکت‌های فعال در این زمینه می‌باشد که شما می توانید از مشاورین و متخصصین این شرکت در زمینه‌ی چگونگی انجام مراحل ترخیص کالا مشورت گرفته و به کمک گروه با تجربه و کاربلد این شرکت به انواع فعالیت‌های تجاری در حوزه بین الملل بپردازید.',
            ]
        },
        {
            type: 'list',
            title: 'آشنایی با مراحل ترخیص کالا از گمرک:',
            para: [
                'همانطور که گفته شد فرآیند واردات کالا در کشورهای مختلف یک فعالیت مهم اقتصادی است که هر تاجر و بازرگان موفقی باید به خوبی با آن آشنا باشد، چرا که کوچکترین بی دقتی موجب می شود کالای  وارداتی شما کالای قاچاق شناخته شود و لذا پیامدهای ناگواری را برای تجارت شما به دنبال داشته باشد.',
                'در واقع مراحل ترخیص کالا از گمرک امری مهم و خطرناک در زمینه تجارت های بین المللی است که باید تاجرین و بازرگانان فعال در حوزه ی بین الملل با قوانین و مقررات مربوط به آن، به خوبی آشنا باشند. شناخت کامل مراحل ترخیص کالا از گمرک موجب می شود که فرآیند جا به جایی کالاها در اسرع وقت و به بهترین شکل ممکن انجام شود. به همین منظور در این بخش از مقاله سعی داریم شما را با مراحل اصلی و مهم از فرآیند ترخیص کالا آشنا نماییم. به طور کلی مراحل ترخیص کالا از گمرک را می توان به صورت زیر دسته بندی نمود:',
            ],
            list: [
                'دریافت پرفرما و پکینگ لیست',
                'اخذ مجوز ثبت سفارش بازرگانی',
                'بیمه کردن کالا هماهنگی جهت بازرسی در مبداء و مقصد',
                'تشکیل پرونده جهت تخصیص ارز و حواله بانکی',
                'ارتباط با شرکت حمل و نقل بین المللی',
                'دریافت اسناد حمل از شرکت های حمل و نقل بین المللی',
                'تکمیل اسناد و تشکیل پرونده',
                'تنظیم پیش نویس دور اظهاری',
                'بررسی و تایید توسط کارشناس فنی گمرکی و بازرگانی',
                'دور اظهاری واردات',
            ]
        }
    ],














    AboutUsTitleMainPage: "درباره ما",
    Lorem100: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد',
    Lorem10: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و گرافیک است",
    MoreDetailsButton: 'جزئیات بیشتر',
    RailroadTransportationCardTitle: "حمل و نقل ریلی",
    railroad_desc: "شرکت آلتن ریل گلستان به عنوان یکی از شرکتهای زیرمجموعه آلتن گروپ لجستیک، از سال 2006 میلادی، فعالیت خود را در حوزه ارائه خدمات فورواردری ریلی بین المللی آغاز نموده است و در حال حاضر با همکاری سایر شرکت های زیرمجموعه آلتن ...",
    MaritimeTransportationCardTitle: "حمل و نقل دریایی",
    RoadTransportationCardTitle: "حمل و نقل جاده ای",
    ReadMore: "بیشتر بخوانید",
    AltenBenefitsCardTitle: "سرعت بالای حمل و نقل",
    LastNewsTitleMainPage: " آخرین اخبار ",
    TitleInformationCardNewsRoad: "نشست ملی راهبردهای مبادلات اقتصادی در مسیر جاده ابریشم",
    TitleInformationCardNewsAirPlane: "پیشنهاد واردات هواپیماهای با عمر بیش از ۲۰ سال به ایران",
    CompanyLocation: "گلستان، گرگان، خیابان شهید بهشتی - رو به روی گرگان جدید یک",
    AlertSubFooter: "کليه حقوق اين سايت متعلق به گروه آلتن می‌باشد",
    DesignBySubFooter: "طراحی و توسعه توسط  altyngroup",

    //main page ended

    AirTransportationTitleServices: "حمل و نقل هوایی",
    ImportsAndExportsTitleServices: "واردات و صادرات",
    ClearanceTitleServices: "ترخیص کالا",
    TitleOfTheTransportsServices: "سرویس {title} آلتن ",
    // CapacityOfAltenTransportationServices: "ظرفیت های  سرویس {title} آلتن",

    AltynRailTransportServiceCapacities: 'ظرفیت های سرویس حمل و نقل ریلی آلتن',
    AltenRoadTransportServiceCapacities: 'ظرفیت های سرویس حمل و نقل چاده ای آلتن',
    CapacitiesOfAltenAirTransportService: 'ظرفیت های سرویس حمل و نقل هوایی آلتن',
    CapacitiesofAltenSeaTransportationService: 'ظرفیت های سرویس حمل و نقل دریایی آلتن',
    AltenImportAndExportServiceCapacities: 'ظرفیت های سرویس صادرات و واردات آلتن',
    AltenClearanceServiceCapacities: 'ظرفیت های سرویس ترخیص کالا آلتن',
    CapacityOfAltenTransportationServicesTitle: "{title}",
    LoremTitle: 'لورم ایپسوم متن ساختگی',

    //end Services Page

    EnterInformationToInquireAboutThePrice: "ورود اطلاعات جهت استعلام قیمت ",
    FirstAndLastNameInputLabel: "نام و نام خانوادگی",
    PhoneNumberInputLabel: "شماره تماس",
    EmailInputLabel: "ایمیل",
    CargoNameInputLabel: "نام محموله",
    HsCodeInputLabel: "HsCode",
    CargoTonnageInputLabel: "تناژ محموله",
    OriginInputLabel: "مبدا",
    DestinationInputLabel: "مقصد",
    MultiRouteInputLabel: "محموله چند مسیره است ؟",
    DegreeOfRiskOfTheGoodsInputLabel: "درجه خطرپذیری کالا",
    PackageTypeInput: "نوع بسته بندی",
    IsTheShipmentDeclared: "آیا محموله اظهار شده است؟",
    Yes: "بله",
    No: "نه",
    SendButtonTitle: "ارسال",
    AlertPricePage: "کارشناسان ما پس از بررسی های لازم با شما تماس خواهند گرفت ",
    TehranIranTitle: "تهران-ایران",
    EsfehanIranTitle: "اصفهان-ایران",
    TabrizIranTitle: "تبریز-ایران",
    singleTrackTitle: "تک مسیر",
    TwoPaths: "دو مسیر",
    ThreePaths: "سه مسیر",
    LevelOne: "سطح یک",
    LevelTwo: "سطح دو",
    LevelThree: "سطح سه",
    Carton: "کارتن",
    CardBoard: "مقوا",
    Plastic: "پلاستیک",
    NameYup: 'نام و نام خانوادگی الزامی است.',
    PhoneYupNumber: 'شماره تلفن باید عددی باشد',
    PhoneYupCh: 'شماره تلفن باید دقیقاً ۱۱ کاراکتر  باشد.',
    PhoneYup: 'شماره تلفن الزامی است.',
    EmailYup: 'ایمیل نا معتبر است',
    EmailYupIN: 'پر کردن ایمیل اجباری است',
    ProductYup: 'نام محموله الزامی است.',
    CodeYup: 'کد HS الزامی است',
    TonnageYup: 'تناژ محموله الزامی است',
    TonnageYupNumber: 'تناژ باید عددی باشد',
    OriginYup: 'مبدا الزامی است.',
    DestinationYup: 'مقصد الزامی است.',
    RoadYup: 'نوع مسیر الزامی است.',
    GradeYup: 'درجه خطرپذیری الزامی است',
    TypeYup: 'نوع بسته‌بندی الزامی است.',

    //end price page


    TitleNewsPage: "اخبار گروه آلتن",

    //end NewsPage


    TitleAboutUsPage: "درباره گروه حمل و نقل آلتن",
    SubcategoriesOfAltenGroup: "زیرمجموعه های گروه آلتن",
    ViewServicesButton: "مشاهده خدمات",
    AltenHeritage: 'آلتن میراث',

    //end AboutUs Page


    ContactUs: 'با ما در ارتباط باشید',
    PhoneNumbers: "شماره های تماس",
    WhatsAppAndTelegram: "واتسپ و تلگرام",
    SocialMedia: "شبکه های اجتماعی",
    mapLocation: "موقعیت دفتر مرکزی آلتن روی نقشه",

    //end Contact us

    HomeAndNews: 'خانه/اخبار/',
    Pm: 'ب.ظ',
    Am: 'ق.ظ',


    chartTitle: 'چارت سازمانی',
    emptyGallery: 'گالری تصاویر خالی است',
    galleryTitle: 'عنوان گالری : ',
};